export interface LocalDateTimeRange {
  from: string;
  to: string;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

export function toLocalDateTimeFieldValue(date: Date): string {
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join('-') + `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function localDateTimeFieldToIso(value: string): string | undefined {
  if (!value.trim()) return undefined;
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date.toISOString() : undefined;
}

export function isoToLocalDateTimeFieldValue(value?: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? toLocalDateTimeFieldValue(date) : '';
}

export function parseLocalDateTimeField(value: string): number | null {
  if (!value.trim()) return null;
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) ? ms : null;
}

export function currentLocalDayDateTimeRange(now = new Date()): LocalDateTimeRange {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);

  const end = new Date(now);
  end.setHours(23, 59, 59, 999);

  return {
    from: toLocalDateTimeFieldValue(start),
    to: toLocalDateTimeFieldValue(end),
  };
}

export function currentLocalDayIsoRange(now = new Date()): LocalDateTimeRange {
  // Computed from Date objects directly: the datetime-local field format is minute
  // precision, so round-tripping the end boundary would collapse it to 23:59:00.000.
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  return { from: start.toISOString(), to: end.toISOString() };
}
